import React, { useContext, useEffect, useState } from "react";
import { Navbar, Container, Button, Offcanvas } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import { LoginContext } from "../context/LoginContext";
import { DestinazioneContext } from "../context/DestinazioneContext";
import { MdDarkMode, MdLightMode, MdLogout } from 'react-icons/md';
import { FaBars, FaFileAlt, FaTable, FaMapMarkerAlt, FaBoxes, FaClipboardList, FaRandom, FaCog } from 'react-icons/fa';
import {
  formatConfiguratorOrarioDisplay,
  isConfiguratorOrarioValueValid,
} from "../utils/configuratorOrarioDisplay";

function NavigationBar() {
  const { darkMode, setDarkMode } = useContext(ThemeContext);
  const { isAuthenticated, logout, companyInfo } = useContext(LoginContext);
  const { logoutDestinazione, destinazione } = useContext(DestinazioneContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  const [isDefaultUser, setIsDefaultUser] = useState(false);

  const isLoginPage = location.pathname === '/' || location.pathname === '/login' || location.pathname === '/registrazione';

  useEffect(() => {
    const syncAdminMenu = () => {
      setIsDefaultUser(localStorage.getItem('isDefaultUser') === 'true');
    };
    syncAdminMenu();
    window.addEventListener('destinazioneChanged', syncAdminMenu);
    return () => window.removeEventListener('destinazioneChanged', syncAdminMenu);
  }, [location.pathname]);

  useEffect(() => {
    const openMenu = () => setShowMenu(true);
    window.addEventListener('panify-open-menu', openMenu);
    return () => window.removeEventListener('panify-open-menu', openMenu);
  }, []);

  const isSuperuserNav =
    typeof window !== 'undefined' && localStorage.getItem('isSuperuser') === 'true';
  const dd = destinazione?.datiDestinazione;
  const destBloccoOn =
    !isSuperuserNav && String(dd?.abilita_blocco ?? '').trim() === '1';
  const destOrarioRaw = dd?.orarioblocco_dest;
  const destOverrideValid =
    destBloccoOn && isConfiguratorOrarioValueValid(destOrarioRaw);
  const bloccoValidoGlobale = isConfiguratorOrarioValueValid(companyInfo?.orarioBlocco);
  const navOrarioMostrato = destOverrideValid
    ? formatConfiguratorOrarioDisplay(destOrarioRaw)
    : bloccoValidoGlobale
      ? formatConfiguratorOrarioDisplay(companyInfo.orarioBlocco)
      : '';
  const showNavOrarioStrip = isAuthenticated && navOrarioMostrato !== '';

  const handleLogout = () => {
    logoutDestinazione();
    logout();
    navigate("/");
  };

  const go = (path) => {
    setShowMenu(false);
    navigate(path);
  };

  return (
    <>
    <Navbar 
      expand="lg" 
      fixed="top"
      variant="dark"
      className="shadow-sm navbar-panify"
      style={{ backgroundColor: '#59A9DC' }}
    >
      <Container className="d-flex justify-content-between align-items-center"> 
        <Navbar.Brand as={Link} to={isAuthenticated ? "/home" : "/"} className="d-flex align-items-center py-0 me-0 text-start flex-shrink-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo/Immagine-navbar.jpg`}
            alt="Panify Cloud"
            className="me-2"
            style={{ height: 56, width: 'auto', objectFit: 'contain', flexShrink: 0 }}
          />
          <span className="navbar-brand-title" style={{ fontSize: "1.5rem", fontWeight: "bold" }}>Panify Cloud</span>
        </Navbar.Brand>

        {showNavOrarioStrip && (
          <div className="d-none d-lg-block text-center navbar-text">
            <span style={{ fontSize: "0.9rem", fontWeight: "500" }}>
              <i className="fas fa-clock me-2"></i>
              Ordini effettuabili per domani entro le ore: <strong>{navOrarioMostrato}</strong>
            </span>
          </div>
        )}

        <div className="d-flex align-items-center gap-2">
          {isAuthenticated && !isLoginPage && (
            <Button
              variant={showMenu ? 'light' : 'outline-light'}
              className="d-lg-none navbar-icon-btn"
              onClick={() => setShowMenu(true)}
              aria-label="Menu"
              title="Menu"
              aria-pressed={showMenu}
            >
              <FaBars size={18} />
            </Button>
          )}

          {isAuthenticated && !isLoginPage && (
            <Button 
              variant="outline-light"
              className="navbar-icon-btn"
              onClick={handleLogout}
              title="Logout"
              aria-label="Logout"
            >
              <MdLogout size={20} />
            </Button>
          )}

          <Button 
            className="navbar-toggle-btn navbar-icon-btn"
            variant="outline-light" 
            onClick={() => setDarkMode(!darkMode)}
            title={darkMode ? "Modalità chiara" : "Modalità scura"}
            aria-label={darkMode ? "Modalità chiara" : "Modalità scura"}
          >
            {darkMode ? <MdLightMode size={20} /> : <MdDarkMode size={20} />}
          </Button>
        </div>

      </Container>

      {showNavOrarioStrip && (
        <div 
          className="w-100 d-lg-none border-top navbar-mobile-orario"
          style={{ 
            textAlign: 'center',
            backgroundColor: '#59A9DC',
            color: '#fff'
          }}
        >
          <Container>
            <span>
              <i className="fas fa-clock me-2"></i>
              Blocco domani: <strong>{navOrarioMostrato}</strong>
            </span>
          </Container>
        </div>
      )}
    </Navbar>

    <Offcanvas
      show={showMenu}
      onHide={() => setShowMenu(false)}
      placement="bottom"
      className={`mobile-app-menu ${darkMode ? 'text-bg-dark' : ''}`}
    >
      <Offcanvas.Header closeButton closeVariant={darkMode ? 'white' : undefined}>
        <Offcanvas.Title>Menu</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-grid gap-2">
          <Button variant={location.pathname === '/documenti' ? 'primary' : (darkMode ? 'outline-light' : 'outline-dark')} onClick={() => go('/documenti')}>
            <FaFileAlt className="me-2" /> Documenti
          </Button>
          <Button variant={location.pathname === '/documenti/tabella-settimanale' ? 'primary' : (darkMode ? 'outline-light' : 'outline-dark')} onClick={() => go('/documenti/tabella-settimanale')}>
            <FaTable className="me-2" /> Tabella settimanale
          </Button>
          {isDefaultUser && (
            <>
              <Button variant={location.pathname === '/destinazioni' ? 'primary' : (darkMode ? 'outline-light' : 'outline-dark')} onClick={() => go('/destinazioni')}>
                <FaMapMarkerAlt className="me-2" /> Destinazioni
              </Button>
              <Button variant={location.pathname === '/magazzino' ? 'primary' : (darkMode ? 'outline-light' : 'outline-dark')} onClick={() => go('/magazzino')}>
                <FaBoxes className="me-2" /> Prodotti
              </Button>
              <Button variant={location.pathname === '/preordini' ? 'primary' : (darkMode ? 'outline-light' : 'outline-dark')} onClick={() => go('/preordini')}>
                <FaClipboardList className="me-2" /> Preordini
              </Button>
              <Button variant={location.pathname === '/smistamento' ? 'primary' : (darkMode ? 'outline-light' : 'outline-dark')} onClick={() => go('/smistamento')}>
                <FaRandom className="me-2" /> Smistamento
              </Button>
              <Button variant={location.pathname === '/admin-settings' ? 'primary' : (darkMode ? 'outline-light' : 'outline-dark')} onClick={() => go('/admin-settings')}>
                <FaCog className="me-2" /> Impostazioni
              </Button>
            </>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
    </>
  );
}

export default NavigationBar;
